import {
  GetMyOptionsDtoResVoice,
  GetMyOptionsDtoResVoiceLang,
} from "@/shared/api/generated"

import { autoDetectBrowserLang } from "@/shared/utils"
import { create } from "zustand"

const INTERFACE_LANG_TO_VOICE_LANG: Record<
  string,
  GetMyOptionsDtoResVoiceLang
> = {
  en: GetMyOptionsDtoResVoiceLang.ENGLISH,
  es: GetMyOptionsDtoResVoiceLang.SPANISH,
  fr: GetMyOptionsDtoResVoiceLang.FRENCH,
  it: GetMyOptionsDtoResVoiceLang.ITALIAN,
  pt: GetMyOptionsDtoResVoiceLang.PORTUGUESE,
}

export const getDefaultLanguage = () => {
  const lang = autoDetectBrowserLang()
  if (!lang)
    return INTERFACE_LANG_TO_VOICE_LANG[GetMyOptionsDtoResVoiceLang.ENGLISH]
  return INTERFACE_LANG_TO_VOICE_LANG[lang]
}

export const OnboardingStep = {
  SELECT_LANGUAGE: "select-language",
  SELECT_VOICE: "select-voice",
} as const

type OnboardingStep = (typeof OnboardingStep)[keyof typeof OnboardingStep]

interface Store {
  selectedLanguage: GetMyOptionsDtoResVoiceLang | null
  setSelectedLanguage: (language: GetMyOptionsDtoResVoiceLang | null) => void

  selectedVoice: GetMyOptionsDtoResVoice | null
  setSelectedVoice: (voice: GetMyOptionsDtoResVoice | null) => void

  //
  step: OnboardingStep
  setStep: (step: OnboardingStep) => void
}

export const useOnboardingStore = create<Store>()(set => ({
  step: OnboardingStep.SELECT_LANGUAGE,
  setStep: (step: OnboardingStep) => set({ step }),

  selectedLanguage: null,
  setSelectedLanguage: (language: GetMyOptionsDtoResVoiceLang | null) =>
    set({ selectedLanguage: language }),

  selectedVoice: null,
  setSelectedVoice: (voice: GetMyOptionsDtoResVoice | null) =>
    set({ selectedVoice: voice }),
}))
